import A1 from 'assets/A1.svg?react';
import A2 from 'assets/A2.svg?react';
import B1 from 'assets/B1.svg?react';
import B2 from 'assets/B2.svg?react';
import C1 from 'assets/C1.svg?react';
import C2 from 'assets/C2.svg?react';
import React from 'react';

export interface CefrMetaEntry {
  en: string;
  color: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const CEFR_META: Record<string, CefrMetaEntry> = {
  A1: { en: 'Beginner', color: '#27CCBC', Icon: A1 },
  A2: { en: 'Elementary', color: '#9B7CFF', Icon: A2 },
  B1: { en: 'Intermediate', color: '#777BFF', Icon: B1 },
  B2: { en: 'Upper-Intermediate', color: '#3B2C93', Icon: B2 },
  C1: { en: 'Advanced', color: '#2A2540', Icon: C1 },
  C2: { en: 'Proficiency', color: '#141414', Icon: C2 },
};

export const DEFAULT_ACCENT = '#3B2C93';

export const hexToRgba = (hex: string, a: number) => {
  const h = hex.replace('#', '');
  return `rgba(${parseInt(h.slice(0, 2), 16)}, ${parseInt(
    h.slice(2, 4),
    16,
  )}, ${parseInt(h.slice(4, 6), 16)}, ${a})`;
};
